import React, { useEffect } from 'react';
import TutorialManager from '@src/shared/components/Tutorial/TutorialManager';
import { TUTORIAL_DASHBOARD_REMINDER } from '@src/shared/components/Tutorial/TutorialsContainer';
import { useOnboardingStore } from '@src/shared/store/onboarding/onboarding-store';
import { useTutorialActions } from '@src/shared/context/tutorial';
import styles from './DashboardOnboardingTutorialReminder.module.scss';
import { useTranslation } from 'react-i18next';
import PIEText from '@src/shared/components/PIEText';
import { IconClose } from '@justeattakeaway/pie-icons-react';
export const DashboardOnboardingTutorialReminder = () => {
  const { onboardingActive, reminderActive, setReminderActive } = useOnboardingStore();
  const { startTutorial } = useTutorialActions();
  const { t } = useTranslation();

  const onClose = () => {
    setReminderActive(false);
  };

  useEffect(() => {
    window.addEventListener('beforeunload', () => {
      setReminderActive(false);
    });
  }, []);

  /*
    onboarding_dashboard
    TUTORIAL_REMINDER_CONTENT
    TUTORIAL_REMINDER_OK_BUTTON
   */
  const StepContent = ({ closeTutorial }: any) => {
    return (
      <div className={styles.tutorial_reminder_content_container}>
        <div className={styles.tutorial_reminder_content}>
          <PIEText
            text={t('onboarding_dashboard.TUTORIAL_REMINDER_CONTENT')}
            color="var(--xds-color-content-default)"
            size="var(--xds-font-size-14)"
            fontWeight="var(--xds-font-weight-regular)"
            truncate
          />
          <IconClose
            onClick={() => {
              onClose();
              closeTutorial();
            }}
            size="m"
            className={styles.tutorial_reminder_close_button}
          />
        </div>
        <div
          onClick={() => {
            closeTutorial();
            onClose();
          }}
          className={styles.tutorial_reminder_action_holder}
        >
          <PIEText
            text={t('onboarding_dashboard.TUTORIAL_REMINDER_OK_BUTTON')}
            color="var(--xds-color-content-default)"
            size="var(--xds-font-size-14)"
            fontWeight="var(--xds-font-weight-bold)"
            truncate
          />
        </div>
      </div>
    );
  };

  const getSelector = () => {
    const alternateHeaderUserIconSelectorQuery = `[data-qa="mobile-header-show-user-menu-button"]`;
    const alternateHeaderUserIcon = document.querySelector(alternateHeaderUserIconSelectorQuery);
    if (alternateHeaderUserIcon) {
      return alternateHeaderUserIconSelectorQuery;
    } else {
      return '#user-logo';
    }
  };

  useEffect(() => {
    if (onboardingActive === false) {
      if (reminderActive) {
        setTimeout(() => {
          startTutorial(TUTORIAL_DASHBOARD_REMINDER);
        }, 500);
      }
    }
  }, [onboardingActive, reminderActive]);

  return (
    (reminderActive && (
      <TutorialManager
        steps={[
          {
            targetElementSelector: getSelector(),
            content: ({ closeTutorial }) => <StepContent closeTutorial={closeTutorial} />,
            position: 'bottom',
          },
        ]}
        tutorialID={TUTORIAL_DASHBOARD_REMINDER}
      />
    )) || <></>
  );
};
